export default {
    getWorkIcon(icon) {
        return {
            lock: require('../../../work/images/icons/padlock.svg'),
            unlock: require('../../../work/images/icons/padlock-unlock.svg'),
        }[icon];
    }
}